import slugify from "slugify";
import type { MittwaldApi } from "../../api/Mittwald";
import { mittwaldApi } from "../../api/Mittwald";

export type AppApiData = MittwaldApi.Components.Schemas.De_Mittwald_V1_App_App;

export enum AppNames {
  joomla = "Joomla!",
  php = "PHP",
  phpworker = "PHP-Worker",
  shopware6 = "Shopware 6",
  shopware5 = "Shopware 5",
  typo3 = "TYPO3",
  bookstack = "BookStack",
  wordpress = "WordPress",
  matomo = "Matomo",
  contao = "Contao",
  node = "Node.js",
  staticapp = "Static Files",
  nextcloud = "Nextcloud",
  magento = "Magento",
  grav = "Grav",
  drupal = "Drupal Core",
  neos = "NEOS",
  moodle = "Moodle",
  prestashop = "PrestaShop",
  humhub = "HumHub",
  python = "Python",
}

export class App {
  public readonly data: AppApiData;
  public readonly name: string;
  public readonly id: string;
  public readonly slug: string;

  private constructor(data: AppApiData) {
    this.data = Object.freeze(data);
    this.name = data.name;
    this.id = data.id;
    this.slug = slugify(data.name, {
      lower: true,
    });
  }

  public static fromApiData(data: AppApiData): App {
    return new App(data);
  }

  public static useLoadById(id: string): App {
    const data = mittwaldApi.appGetApp
      .getResource({ path: { appId: id } })
      .useWatchData();
    return new App(data);
  }
}

export default App;
